module.exports = __webpack_public_path__ + "img/title2.17a5a9de.png";